import { userByIdOptions } from "@pulse/api/queryApi";
import GeneratedPfp from "@pulse/features/Header/toolbar/generatedPfp";
import { useStorage } from "@pulse/hooks/contextHooks";
import { useQuery } from "@tanstack/react-query";
import { Spinner } from "frontend-components";

export default function Pfp({ userId }: { userId: number }) {
    const { url } = useStorage();
    const { data: user, isPending } = useQuery(userByIdOptions({ id: userId }));

    return user ? (
        user.picture ? (
            <img src={`${url}/${user.picture}`} className="rounded-full" />
        ) : (
            <GeneratedPfp
                userId={user.id}
                initiales={[user.firstName, user.lastName]
                    .filter((name) => !!name)
                    .map((name) => name?.charAt(0)?.toUpperCase())
                    .join("")}
            />
        )
    ) : (
        <div className="w-full h-full flex justify-center">
            <div className="h-full flex flex-col justify-center">{isPending && <Spinner />}</div>
        </div>
    );
}
